import './ResumeButton.scss';
import Resume from '../assets/documents/resume.pdf';
import { FormattedMessage } from 'react-intl';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const ResumeButton = () => {
  return (
    <a
      className='resume-button'
      href={ Resume }
      target='_blank'
      rel="noreferrer"
      aria-label='open resume'
    >
      <div className='resume-button__text-container'>
        <FormattedMessage id='VIEW_RESUME' />
        <OpenInNewIcon className='resume-button__icon' fontSize='small' />
      </div>
    </a>
  );
};